// extracted by mini-css-extract-plugin
export default {"badge":"styles_badge__aG-Xm","disabled":"styles_disabled__Q+TMY","icon":"styles_icon__QbxTZ"};